import ToastUtils from '../utils/ToastUtils';
import { isInApp, goAppLogin, getEnvironment } from '@/utils/Mobile';
export const goSideLogin = (side) => {
    let env = getEnvironment();

    let origin = window.location.origin;
    let redirect = `${window.location.href}`;
    //被嵌入到了别的项目
    if (env) {
        let topRedirect = `${window.top.location.href}`;
        if (env === 'pc') {
            window.top.location.replace(`${origin}/login?redirect=${topRedirect}`);
        }
        if (env === 'h5') {
            window.top.location.replace(`${origin}/mobile/login?redirect=${encodeURIComponent(topRedirect)}`);
        }
        if (env === 'app') {
            goAppLogin();
        }
        return false;
    }
    if (side === 'web') {
        window.location.replace(`${origin}/login?redirect=${redirect}`);
    } else {
        window.location.replace(`${origin}/mobile/login?redirect=${encodeURIComponent(redirect)}`);
    }
};
const goLogin = () => {
        if (!window.location.pathname.includes('no-auth') && !window.location.pathname.includes('/login')) {
            let side = window.location.pathname.includes('/mobile') ? 'mobile' : 'web';
            goSideLogin(side);
            // window.location.href = `https://${window.location.host}/login?redirect=${window.location.href}`;
            // console.log("跳到登录页");
        }
    },
    request = (config) => {
        if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json';
        }
        return config;
    },
    requestError = (error) => {
        return Promise.reject(error);
    },
    response = (response) => {
        const res = response.data;
        let message = '';

        if (response.status === 200) {
            switch (response.data.code) {
                case 'A0128':
                    message = '登录状态失效';
                    break;
                case 'A0129':
                    message = '登录状态失效';
                    break;
                case 'A0130':
                    message = '登录状态失效';
                    break;
                case 'A0131':
                    message = '登录账号被顶下线';
                    break;
                case 'A0132':
                    message = '登录账号被踢下线';
                    break;
                case 'A0300':
                    message = '访问权限异常';
                    break;
                default:
                    message = '';
                    break;
            }
            if (message) {
                //跳过异常拦截和异常提示
                let requestUrl = response.request.responseURL;
                if (requestUrl.includes('/user/learn-business/v1/project-check') || requestUrl.includes('/user/learn-business/v1/start-playing')) {
                    return res;
                }
                ToastUtils.showAbnormalToast(message);
                setTimeout(() => {
                    goLogin();
                }, 2000);
                return Promise.reject({ msg: message });
            }
            return res;
        }
    },
    responseError = (error) => {
        let message = '';

        if (error && error.response) {
            switch (error.response.status) {
                case 302:
                    message = '接口重定向了！';
                    break;
                case 400:
                    message = '参数不正确！';
                    break;
                case 401:
                    message = '您未登录，或者登录已经超时，请先登录！';
                    break;

                case 403:
                    message = '您没有权限操作！';
                    break;
                case 404:
                    message = 'api地址出错！';
                    break;
                case 408:
                    message = '请求超时！';
                    break;
                case 409:
                    message = '系统已存在相同数据！';
                    break;
                case 500:
                    message = '服务器内部错误！';
                    break;
                case 501:
                    message = '服务未实现！';
                    break;
                case 502:
                    message = '网关错误！';
                    break;
                case 503:
                    message = '服务不可用！';
                    break;
                case 504:
                    message = '服务暂时无法访问，请稍后再试！';
                    break;
                case 505:
                    message = 'HTTP 版本不受支持！';
                    break;
                default:
                    message = '异常问题，请联系管理员！';
                    break;
            }
        }
        return Promise.reject({ msg: message, error: error.response });
    },
    timeout = 20000,
    // 不缓存cookie
    withCredentials = true;

export default {
    request,
    requestError,
    response,
    responseError,
    timeout,
    withCredentials
};
